import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LegalPageLayout from "../components/LegalPageLayout";
import { baseUrl } from "../config/apiConfig";
import { legalTranslations } from "../translations/legal";
import "./AccountDeletion.css";

const LANG_KEY = "lineo-lang";

function getLangForApi() {
  const saved = localStorage.getItem(LANG_KEY);
  const supported = ["tr", "en", "de", "fr", "ru", "es"];
  return supported.includes(saved) ? saved : "tr";
}

export default function AccountDeletion() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const lang = localStorage.getItem(LANG_KEY) || "tr";
  const t = legalTranslations[lang] || legalTranslations.tr;

  const requestOTP = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${baseUrl}/api/auth/account/deletion/request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": getLangForApi(),
        },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.message || data.errors?.[0]?.msg || "Bir hata oluştu");
      }
      setStep(2);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const confirmDeletion = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(
        `${baseUrl}/api/auth/account/deletion/request/confirm`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": getLangForApi(),
          },
          body: JSON.stringify({ email: email.trim(), otp: otp.trim() }),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.message || data.errors?.[0]?.msg || "Bir hata oluştu");
      }
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 6);
    setOtp(val);
  };

  if (success) {
    return (
      <LegalPageLayout titleKey="accountDeletionTitle">
        <div className="account-deletion-success">
          <div className="account-deletion-success-icon">✓</div>
          <p className="account-deletion-success-message">{t.accountDeletionSuccess}</p>
          <button
            type="button"
            className="account-deletion-btn account-deletion-btn--primary"
            onClick={() => navigate("/")}
          >
            {t.accountDeletionGoHome}
          </button>
        </div>
      </LegalPageLayout>
    );
  }

  return (
    <LegalPageLayout titleKey="accountDeletionTitle">
      <div className="account-deletion">
        <p className="account-deletion-desc">{t.accountDeletionDesc}</p>

        {step === 1 ? (
          <form onSubmit={requestOTP} className="account-deletion-form">
            <div className="account-deletion-field">
              <label htmlFor="email">{t.accountDeletionEmailLabel}</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@email.com"
                required
                disabled={loading}
                autoComplete="email"
              />
            </div>
            {error && <p className="account-deletion-error">{error}</p>}
            <button
              type="submit"
              className="account-deletion-btn account-deletion-btn--primary"
              disabled={loading}
            >
              {loading ? t.accountDeletionSending : t.accountDeletionSendOtp}
            </button>
          </form>
        ) : (
          <form onSubmit={confirmDeletion} className="account-deletion-form">
            <p className="account-deletion-otp-info">{t.accountDeletionOtpInfo}</p>
            <div className="account-deletion-field">
              <label htmlFor="otp">{t.accountDeletionOtpLabel}</label>
              <input
                id="otp"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                value={otp}
                onChange={handleOtpChange}
                placeholder="123456"
                required
                disabled={loading}
                autoComplete="one-time-code"
              />
            </div>
            {error && <p className="account-deletion-error">{error}</p>}
            <div className="account-deletion-actions">
              <button
                type="submit"
                className="account-deletion-btn account-deletion-btn--danger"
                disabled={loading || otp.length !== 6}
              >
                {loading ? t.accountDeletionDeleting : t.accountDeletionConfirm}
              </button>
              <button
                type="button"
                className="account-deletion-btn account-deletion-btn--secondary"
                onClick={() => {
                  setStep(1);
                  setOtp("");
                  setError("");
                }}
                disabled={loading}
              >
                {t.accountDeletionBack}
              </button>
            </div>
          </form>
        )}
      </div>
    </LegalPageLayout>
  );
}
